import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'How It Works',
    href: '#how-it-works'
  }, {
    name: 'Use Cases',
    href: '#use-cases'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6,
    ease: [0.22, 1, 0.36, 1]
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-primary/90 backdrop-blur-md border-b border-border py-4' : 'bg-transparent py-6'}`} data-id="element-92">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-93">
        <div className="flex flex-col" data-id="element-94">
          <span className="font-serif text-xl md:text-2xl font-semibold text-text-light tracking-wide" data-id="element-95">
            THE MBA COMPANY
          </span>
          <a href="https://www.criticalfuture.ai" target="_blank" rel="noopener noreferrer" className="text-[10px] md:text-xs text-accent tracking-widest uppercase mt-1 hover:underline" data-id="element-96">
            by Critical Future
          </a>
        </div>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-97">
          <div className="flex space-x-6" data-id="element-98">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm text-text-muted hover:text-accent transition-colors duration-200" data-id="element-99">
                {link.name}
              </a>)}
          </div>
          <a href="#contact" className="bg-tertiary text-white px-5 py-2 text-sm uppercase tracking-wider hover:bg-tertiary/90 transition-all duration-300 inline-block" data-id="element-100">
            Submit a Challenge
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-text-light" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-101">
          {isMobileMenuOpen ? <X size={24} data-id="element-102" /> : <Menu size={24} data-id="element-103" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {isMobileMenuOpen && <motion.div initial={{
      opacity: 0,
      height: 0
    }} animate={{
      opacity: 1,
      height: 'auto'
    }} exit={{
      opacity: 0,
      height: 0
    }} className="md:hidden bg-primary border-b border-border" data-id="element-104">
          <div className="flex flex-col px-6 py-4 space-y-4" data-id="element-105">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm text-text-muted hover:text-accent transition-colors duration-200 py-2 border-b border-border/50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-106">
                {link.name}
              </a>)}
            <a href="#contact" className="bg-tertiary text-white px-5 py-3 text-sm uppercase tracking-wider font-medium mt-4 inline-block text-center" onClick={() => setIsMobileMenuOpen(false)} data-id="element-107">
              Submit a Challenge
            </a>
          </div>
        </motion.div>}
    </motion.nav>;
}